<div class="wrapper">
  <div class="settings">
    <ng-container *ngFor="let item of settings; let index = index">
      <div class="item" (click)="selectMenu(item)">
        <span class="title">{{ item.title | translate }}</span>
        <span class="value">{{ item.value }}</span>
      </div>
    </ng-container>
  </div>
  <customize-button (click)="logOut()" type="primary-linear" size="large-medium" class="logout">
    {{ 'logout' | translate }}
  </customize-button>
</div>
